import React from "react";
import posterImage from '../../assets/coverBackground/trackHeaderPoster.svg';
import arrowRightUpIcon from "../../assets/track-icon/info-icons/arrow-up-right-white.svg";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column'
        },
        width: '100%',
        backgroundSize: 'contain',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    mainContent: {
        '& button': {
            [theme.breakpoints.down("sm")]: {
                width: '100%',
            },
            textTransform: 'none',
            background: '#171717 !important',
            padding: '1rem',
            borderRadius: '8px',
            color: '#FFF',
            height: '3rem',
            maxWidth: 'fit-content',
            '&:hover': {
                background: '#030303'
            },
            '& img': {
                width: '0.8rem',
                marginBottom: '-1px',
            }
        },
    },
    responsiveImg: {
        maxWidth: '100%'
    },
    flexWithGap: {
        [theme.breakpoints.down("md")]: {
            flexDirection: 'column'
        },
        display: 'flex',
        gap: '1rem',
        alignItems: 'baseline'
    }
}))

const TrackPitch = ({ trackPitch, ...props }) => {

    const classes = useStyles();

    return (
        <section
            className={`${classes.root} ${props.textInfoContainers}`}
            style={{ backgroundImage: "url(" + posterImage + ")" }}>
            <div className={classes.mainContent}>
                <h1>{trackPitch?.title}</h1>
                <p>{trackPitch?.description}</p>
                <div className={classes.flexWithGap}>
                    <Button onClick={props.moveToProducts}>
                        <span>Start now&nbsp;&nbsp;</span>
                        <img src={arrowRightUpIcon} />
                    </Button>
                    <i>No Fees Until You Succeed</i>
                </div>
            </div>
            <div>
                <img src={trackPitch?.image} className={classes.responsiveImg} />
            </div>
        </section>
    )
}

export default TrackPitch;